/**
 * Created by Alejandro Martinez on 16/07/20.
 */
import playersGeneral from '@/store/modules/players/general';
import playersPossession from '@/store/modules/players/possession';
import playersOffensive from '@/store/modules/players/offensive';
import playersDefensive from '@/store/modules/players/defensive';

export default {
  playersGeneral,
  playersPossession,
  playersOffensive,
  playersDefensive,
};
